import { AccessControlFeatureKey } from '@shared/constants/features.const';

export const PERIMETERS_FEATURE = [AccessControlFeatureKey.FtsPerimeters] as const;
